export default "/assets/images/app-showcase-02.jpg?856a34bf5a7caac945f3d842212a3c5f";